
import { sendHTTPRequest } from "@/util/http.ts";
import { goalbookUrls } from "@/util/links.js";
import { SSOProviderInfoMap } from "@/authentication/auth_types.ts";

export async function reloginCheck(duration: number, settings: { return_url: string }): Promise<boolean> {
  try {
    const response = await sendHTTPRequest({
      url: `${import.meta.env.VITE_TOOLKIT_URL}/relogin_check/${duration}`,
      urlParams: settings,
    })
    const { force_relogin } = await response.json() as { force_relogin: boolean }
    return force_relogin
  } catch(e) {
    console.error(new Error('Failed relogin check request', { cause: e }))
    return true
  }
}

export async function getSSOProviderInfo(): Promise<SSOProviderInfoMap> {
  try {
    const response = await sendHTTPRequest({
      url: `${goalbookUrls.accounts}/providers`,
      includeCredentials: true
    })
    return await response.json() as SSOProviderInfoMap
  } catch(e) {
    throw new Error('Failed to fetch SSO providers', { cause: e })
  }
}

export async function postUserLogin(email: string, password: string, token: string): Promise<void> {
  try {
    await sendHTTPRequest({
      url: `${goalbookUrls.accounts}/api/users/signin`,
      method: 'POST',
      formData: {
        email: email,
        password: password,
        source: 'toolkit',
        ref: 'login_modal',
        authenticity_token: token
      },
      includeCredentials: true,
      addlHeaders: {
        'X-CSRF-Token': token
      }
    })
  } catch (e) {
    throw new Error('Failed POST sign-in', { cause: e })
  }
}

export async function postOneTimeCodeRequest(email: string, token: string): Promise<void> {
  try {
    const response = await fetch(`${goalbookUrls.auth}/onetimecode/request`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams({
        email,
        authenticity_token: token,
        dest: 'toolkit'
      }).toString()
    })

    if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
  } catch (e) {
    throw new Error('Failed POST one-time-code request', { cause: e })
  }
}

export async function postOneTimeCodeVerify(email: string, code: string, token: string): Promise<void> {
  try {
    const response = await fetch(`${goalbookUrls.auth}/onetimecode/verify`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams({
        email,
        code,
        authenticity_token: token,
        dest: 'toolkit',
        relogin: 'true'
      }).toString()
    })

    if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
  } catch (e) {
    throw new Error('Failed POST one-time-code verify', { cause: e })
  }
}